import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Input, Row, BackTop, Select, Button, AutoComplete, Modal } from 'antd';
import useBreakpoints from 'antd/lib/grid/hooks/useBreakpoint'
import InfiniteScroll from 'react-infinite-scroll-component';
import { BsFillArrowUpCircleFill, BsCheckSquare } from 'react-icons/bs';
import { AiOutlineLeftCircle, AiOutlineRightCircle } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router';
import { FilterOutlined, FilterFilled } from '@ant-design/icons';
import useFetch from '../../_fetch';
import { Loader } from '../../components/loader';

import './styles.less';
import { HotelCard } from '../../components/HotelCard';
import { setSearch } from '../../store/action/const';
import { accommodation_types, top_amenities } from './amenitiesFilters';
import { hotel_facts } from '../../common/facts';

const { Option } = Select;
const { Search } = Input;

export default function HotelSearch() {

	const [data, setData] = useState([]);
	const [alternates, setAlternates] = useState([]);
	const [page, setPage] = useState(1);
	const [userFilterVisible, setUserFilterVisible] = useState(false);
	const [filtersVisible, setFiltersVisible] = useState(false);
	const [max, setMax] = useState(0);
	const [classification, setClassification] = useState('');
	const [category, setCategory] = useState('');
	const [type, setType] = useState('');
	const [travelerType, setTravelerType] = useState('');
	const [filter, setFilter] = useState('');
	const [loading, setLoading] = useState(false);
	const [_class, setClass] = useState('position-sticky curtain');
	const [options, setOptions] = useState([]);
	const ref = useRef(0);
	const topAmenitiesContainerRef = useRef(null);

	const { city, country } = useParams();


	const { cities = [], countries = [], search: text } = useSelector(st => st.consts);

	const _fetch = useFetch();
	let dispatch = useDispatch();
	let navigate = useNavigate();
	let breakpoints = useBreakpoints();

	const search = useCallback(async () => {
		try {
			setLoading(true);

			if (!text && !(country || city)) return;

			let url = '';

			if (travelerType) {
				url += `&traveler_type=${travelerType}`
			}
			if (category) {
				url += `&category=${category}`
			}
			if (classification) {
				url += `&classification=${classification}`
			}
			if (type) {
				url += `&type=${type}`
			}
			if (filter) {
				url += `&filter=${filter}`
			}
			if (city) {
				url += `&city=${city}`
			}
			if (country) {
				url += `&country=${country}`
			}

			let res = await _fetch(process.env.REACT_APP_API_URL + `/hotel/search?text=${text}&limit=12&page=${page}${url}`)
			res = await res.json();
			if (res.success) {
				setData([...res.response.hotel_list]);
				setMax(res.response.total_hotels);
				if (res.response.hotel_list.length === 0) {
					setAlternates(res.response.alternates);
				}
			}
		} catch (e) {
			console.log(e);
			toast.error('Some error occurred please try again later');

		} finally {
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [text, filter, travelerType, classification, type, category, country, city]);

	const next = useCallback(async () => {
		try {

			console.log('page loader', page);

			if (page <= 1) return;

			if (!text && !(country || city)) return;

			let url = '';

			if (travelerType) {
				url += `&traveler_type=${travelerType}`
			}
			if (category) {
				url += `&category=${category}`
			}
			if (classification) {
				url += `&classification=${classification}`
			}
			if (type) {
				url += `&type=${type}`
			}
			if (filter) {
				url += `&type=${filter}`
			}
			if (city) {
				url += `&city=${city}`
			}
			if (country) {
				url += `&country=${country}`
			}

			let res = await _fetch(process.env.REACT_APP_API_URL + `/hotel/search?text=${text}&limit=12&page=${page}${url}`)
			res = await res.json();
			if (res.success) {
				setData(val => [...val, ...res.response.hotel_list]);
				setMax(res.response.total_hotels);
			}
		} catch (e) {
			console.log(e);
			toast.error('Some error occurred please try again later');

		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	const leftScrollTopAmenities = () => {
		if (topAmenitiesContainerRef.current) {
			topAmenitiesContainerRef.current.scrollLeft -= 150;
		}
	};

	const rightScrollTopAmenities = () => {
		if (topAmenitiesContainerRef.current) {
			topAmenitiesContainerRef.current.scrollLeft += 150;
		}
	};

	useEffect(() => {
		window.last_scroll = 0;
		if (typeof window !== "undefined") {
			window.addEventListener("scroll", () => {
				if (window.pageYOffset < 50) {
					setClass('op3');
				} else if (window.pageYOffset < 150) {
					if (_class !== 'op4 pt-2 pt-md-4')
						setClass('op4 pt-2 pt-md-4');
				} else {
					if (_class !== 'op5 pt-2 pt-md-4')
						setClass('op5 pt-2 pt-md-4');
				}
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => { search() }, [search]);
	useEffect(() => { next() }, [next]);

	function getImage(images) {
		if (images && Array.isArray(images) && images.length) {
			let image = images.find(e => e.heroImage) ?? images[0];
			if (image.sizes) {
				if (image.sizes["800"]) return image.sizes["800"].href
				else if (image.sizes["1080"]) return image.sizes["1080"].href
				else if (image.sizes["320"]) return image.sizes["320"].href
				else if (image.sizes["2160"]) return image.sizes["2160"].href
			}
			else return 'https://dhv90r5m1wdoe.cloudfront.net/default_bg.png';
		}
		else return 'https://dhv90r5m1wdoe.cloudfront.net/default_bg.png';
	}


	return (
		<div className="container px-4 pt-0 pt-md-4 pb-md-5 gx-md-3 position-relative" id='search-page'>

			<div className={`position-sticky curtain ${_class} pb-0 py-md-3`}>

				<Row className='pb-0 pb-md-2 pt-1 pt-md-0'>
					<Col xs={20} md={{ span: 16, offset: 2 }}
						className='px-1'
					>
						<AutoComplete
							dropdownMatchSelectWidth={252}
							className='w-100'
							options={options}
							onSelect={(val) => {
								console.log(val);
								if (!val) return;
								setData([]);
								setFilter('');
								setPage(1);
								dispatch(setSearch(''));
								let arr = val.split(' (');
								navigate(`/hotels${arr[1] ? `/${arr[1].split(')')[0]}` : ''}/${arr[0]}`);
							}}
							onSearch={(val) => {
								if (!val) return;
								setOptions(() => {
									let str = val.toUpperCase();
									let filtered_options = [
										cities
											.filter(e => e.name.toUpperCase().indexOf(str) !== -1)
											.map(e => ({ value: `${e.name} ${e.country ? `(${e.country.name})` : ''}`, label: `${e.name} ${e.country ? `(${e.country.name})` : ''}` })),

										countries
											.filter(e => e.name.toUpperCase().indexOf(str) !== -1)
											.map(e => ({ value: e.name, label: e.name }))
									].flat();
									return filtered_options;
								})
							}}
							defaultValue={text}
						>
							{
								breakpoints.md ? (
									<Search
										placeholder="Where would you like to go?" allowClear
										enterButton='Search'
										className='header-search w-100 mb-0'
										required={true}
										onSearch={(val) => {
											if (!val) return;
											setData([]);
											setFilter('');
											setPage(1);
											dispatch(setSearch(val));
											navigate('/hotels');
										}}
									/>
								) : (
									<Search
										placeholder="Enter destination" allowClear
										className='header-search w-100 mb-0'
										required={true}
										onSearch={(val) => {
											if (!val) return;
											setData([]);
											setFilter('');
											setPage(1);
											dispatch(setSearch(val));
											navigate('/hotels');
										}}
									/>
								)
							}

						</AutoComplete>
					</Col>
					<Col xs={4} md={4}
						className='px-2 d-flex align-items-center justify-content-center'
					>
						<Button
							onClick={() => {
								if (breakpoints.md) {
									setUserFilterVisible(!userFilterVisible);
								} else {
									ref.current = parseInt(window.scrollY);
									setTimeout(() => {
										setFiltersVisible(!filtersVisible);
									}, 20);
								}
							}}
							className='d-md-none mr-1 mt-1'
							icon={userFilterVisible ? <FilterFilled className='fs-5' style={{ color: '#0081ff' }} /> : <FilterOutlined className='fs-5' />}
							shape='circle'
							size='large'
						/>

						<Button
							onClick={() => {
								if (breakpoints.md) {
									setUserFilterVisible(!userFilterVisible);
								} else {
									ref.current = parseInt(window.scrollY);
									setTimeout(() => {
										setFiltersVisible(!filtersVisible);
									}, 20);
								}
							}}
							className='d-none d-md-flex px-md-4 align-items-center justify-content-center mr-1'
							icon={userFilterVisible ? <FilterFilled className='fs-5' style={{ color: '#0081ff' }} /> : <FilterOutlined className='fs-5' />}
							style={{
								color: 'black',
								border: userFilterVisible ? '2px solid #0081ff' : '2px solid #e7ebf0',
								borderRadius: breakpoints.md ? '100px' : '50%',
								width: breakpoints.md ? '100%' : '55px',
								height: breakpoints.md ? '100%' : '55px',
							}}
						>
							<span
								className='fs-5 mb-0'
								style={{
									fontWeight: '600',
									color: userFilterVisible ? '#0081ff' : '#000'
								}}
							>
								Filters
							</span>
						</Button>
					</Col>
				</Row>

				<div className={`mt-3`}>
					<Row gutter={[0, 16]}
						className='all-filters-row'
					>
						<Col xs={24}>
							<div
								className='top-amenities-container-wrapper'
							>
								<div
									className='top-amenities-container'
									ref={topAmenitiesContainerRef}
								>
									<div
										className='d-flex align-items-top flex-nowrap ta-filters-container'
									>
										{
											top_amenities.map(({ icon, fact }) => (
												<div
													key={fact}
													onClick={() => {
														setData([]);
														setPage(1);
														if (filter === fact) {
															setFilter('');
														} else {
															setFilter(fact);
														}
													}}
													className={`d-flex flex-column align-items-center filter-item pointer ${filter === fact ? 'text-primary' : ''}`}
												>
													<span className='material-symbols-outlined mb-1'>{icon}</span>
													<p className='text-center m-0 ta-filter-title-text'>{hotel_facts.en.facts[fact].label}</p>
												</div>
											))
										}
									</div>
								</div>
								<div
									className='left-scroll-button-container'
									onClick={leftScrollTopAmenities}
								>
									<AiOutlineLeftCircle
										size={30}
									/>
								</div>
								<div
									className='right-scroll-button-container'
									onClick={rightScrollTopAmenities}
								>
									<AiOutlineRightCircle
										size={30}
									/>
								</div>

							</div>


						</Col>
						{
							userFilterVisible && (
								<React.Fragment>
									<Col xs={0} md={6}
										className='d-flex align-items-center justify-content-center'
									>
										<Select
											style={{ width: '100%' }}
											onChange={(val) => {
												setData([]);
												setCategory(val);
											}}
											className='rounded' size='large' mode='multiple'
											placeholder='Filter by Category'
											menuItemSelectedIcon={<BsCheckSquare
												style={{
													color: 'black',
													fontSize: '16px',
												}}
											/>}
										>
											<Option value='Full Service'>Full Service</Option>
											<Option value='Limited Service'>Limited Service</Option>
											<Option value='Motel'>Motel</Option>
											<Option value='Hostel'>Hostel</Option>
											<Option value='Bed &amp; Breakfast'>Bed &amp; Breakfast</Option>
											<Option value='Convention Center'>Convention Center</Option>
											<Option value='Casino'>Casino</Option>
										</Select>
									</Col>
									<Col xs={0} md={6}
										className='d-flex align-items-center justify-content-center'
									>
										<Select
											style={{ width: '100%' }}
											onChange={(val) => {
												setData([]);
												setType(val);
											}}
											className='rounded' size='large' mode='multiple'
											placeholder='Filter by Type'
											menuItemSelectedIcon={<BsCheckSquare
												style={{
													color: 'black',
													fontSize: '16px',
												}}
											/>}
										>
											{
												accommodation_types.map(a => (
													<Option value={a.value} key={a.value}>
														{a.label}
													</Option>
												))
											}
										</Select>
									</Col>
									<Col xs={0} md={6}
										className='d-flex align-items-center justify-content-center'
									>
										<Select
											style={{ width: '100%' }}
											onChange={(val) => {
												setData([]);
												setClassification(val)
											}}
											className='rounded' size='large' mode='multiple'
											placeholder='Filter by Classification'
											menuItemSelectedIcon={<BsCheckSquare
												style={{
													color: 'black',
													fontSize: '16px',
												}}
											/>}
										>
											<Option value='3'>3 Star</Option>
											<Option value='4'>4 Star</Option>
											<Option value='5'>5 Star</Option>
											<Option value='7'>7 Star</Option>
										</Select>
									</Col>
									<Col xs={0} md={6}
										className='d-flex align-items-center justify-content-center'
									>
										<Select
											style={{ width: '100%' }}
											onChange={(val) => {
												setData([]);
												setTravelerType(val)
											}}
											className='rounded' size='large' placeholder='Traveler Type'
											menuItemSelectedIcon={<BsCheckSquare
												style={{
													color: 'black',
													fontSize: '16px',
												}}
											/>}
										>
											<Option value=''>Select traveler type</Option>
											<Option value='397'>Mountain travelers</Option>
											<Option value='399'>Nature lovers</Option>
											<Option value='401'>Seminar and convention travelers</Option>
											<Option value='389'>Families</Option>
											<Option value='387'>Business travelers</Option>
											<Option value='383'>Backpackers</Option>
										</Select>
									</Col>
								</React.Fragment>
							)
						}
					</Row>
				</div>
			</div>

			<div>
				{
					loading ?
						<Loader />
						:
						data.length ?
							<InfiniteScroll
								dataLength={data.length}
								next={() => {
									setPage(page + 1);
								}}
								loader={<Loader />}
								hasMore={max > data.length}
								style={{ overflow: 'visible' }}
								className='mt-4'
							>
								<Row gutter={[breakpoints.md ? 16 : 0, breakpoints.md ? 16 : 24]}>
									{
										data.map((e, i) => (
											<HotelCard
												key={i}
												id={e._id}
												img={getImage(e.images)}
												title={e.names}
												description={Array.isArray(e.texts?.sections) ? e.texts?.sections[0].title : ''}
												url={e.urls[0]?.url}
												facts={e.facts}
												city={e.city.name}
												country={e.country.name}
												rating={e.rating?.global ?? 0}
											/>
										))
									}
								</Row>
							</InfiniteScroll>
							:
							<React.Fragment>
								<p className='my-5 text-center'>No hotels were found matching your filters, you might like these hotels</p>
								<Row gutter={[breakpoints.md ? 16 : 0, breakpoints.md ? 16 : 24]}>
									{
										alternates.map((e, i) => (
											<HotelCard
												key={i}
												id={e._id}
												img={getImage(e.images)}
												title={e.names}
												description={Array.isArray(e.texts?.sections) ? e.texts?.sections[0].title : ''}
												url={e.urls[0]?.url}
												facts={e.facts}
												city={e.city.name}
												country={e.country.name}
												rating={e.rating?.global ?? 0}
											/>
										))
									}
								</Row>
							</React.Fragment>
				}
			</div>

			<BackTop>
				<BsFillArrowUpCircleFill className='text-primary' size={40} />
			</BackTop>

			<Modal
				visible={filtersVisible}
				onCancel={() => setFiltersVisible(false)}
				cancelButtonProps={{ loading: loading }}
				okButtonProps={{ style: { display: 'none' } }}
				title='Filter your favorite hotels'
			>
				<Row gutter={[32, 16]}>
					<Col xs={24} md={5}>
						<Select
							style={{ width: '100%' }}
							onChange={(val) => {
								setData([]);
								setCategory(val)
							}}
							className='rounded' size='large' mode='multiple'
							placeholder='Filter by Category'
							menuItemSelectedIcon={<BsCheckSquare
								style={{
									color: 'black',
									fontSize: '16px',
								}}
							/>}
						>
							<Option value='Full Service'>Full Service</Option>
							<Option value='Limited Service'>Limited Service</Option>
							<Option value='Motel'>Motel</Option>
							<Option value='Hostel'>Hostel</Option>
							<Option value='Bed &amp; Breakfast'>Bed &amp; Breakfast</Option>
							<Option value='Convention Center'>Convention Center</Option>
							<Option value='Casino'>Casino</Option>
						</Select>
					</Col>
					<Col xs={24} md={5}>
						<Select
							style={{ width: '100%' }}
							onChange={(val) => {
								setData([]);
								setType(val)
							}}
							className='rounded' size='large' mode='multiple'
							placeholder='Filter by Type'
							menuItemSelectedIcon={<BsCheckSquare
								style={{
									color: 'black',
									fontSize: '16px',
								}}
							/>}
						>
							{
								accommodation_types.map(a => (
									<Option value={a.value} key={a.value}>
										{a.label}
									</Option>
								))
							}
						</Select>
					</Col>
					<Col xs={24} md={5}>
						<Select
							style={{ width: '100%' }}
							onChange={(val) => {
								setData([]);
								setClassification(val)
							}}
							className='rounded' size='large' mode='multiple'
							placeholder='Filter by Classification'
							menuItemSelectedIcon={<BsCheckSquare
								style={{
									color: 'black',
									fontSize: '16px',
								}}
							/>}
						>
							<Option value='3'>3 Star</Option>
							<Option value='4'>4 Star</Option>
							<Option value='5'>5 Star</Option>
							<Option value='7'>7 Star</Option>
						</Select>
					</Col>
					<Col xs={24} md={6}>
						<Select
							style={{ width: '100%' }}
							onChange={(val) => {
								setData([]);
								setTravelerType(val)
							}}
							className='rounded' size='large' placeholder='Traveler Type'
							menuItemSelectedIcon={<BsCheckSquare
								style={{
									color: 'black',
									fontSize: '16px',
								}}
							/>}
						>
							<Option value=''>Select traveler type</Option>
							<Option value='397'>Mountain travelers</Option>
							<Option value='399'>Nature lovers</Option>
							<Option value='401'>Seminar and convention travelers</Option>
							<Option value='389'>Families</Option>
							<Option value='387'>Business travelers</Option>
							<Option value='383'>Backpackers</Option>
						</Select>
					</Col>
				</Row>
			</Modal>

		</div >

	)
}
